import { useContext, useEffect, useState } from "react";
import { Row, Col, Nav, NavItem, Navbar, Container } from "reactstrap";
import { SchoolContext } from "../../../context/SchoolContext";
import ComnOta from "../CommMgnt/ComnOta";
import ComnIwane from "../CommMgnt/ComnIwane";
import ComnFukida from "./ComnFukida";
import ComnHatazawa from "./ComnHatazawa";
import ComnSecondJunior from "./ComnSecondJunior";
import ComnJozai from "./ComnJozai";
import ComnKiyomidai from "./ComnKiyomidai";
import ComnTest from "./ComnTest";
import ComnKoshigaya from "./ComnKICKoshigaya";
import ComnKicSayama from "./ComnSayama";
import ComnAtsugi from "./ComnAtsugi";
import { useHistory } from "react-router-dom";
import { getDeviceId } from "../../../api/api";
import { idExists } from "../../../utils/NumberUtils";
import ComnKicAkiruno from "./ComnAkiruno";
import ComnHokkaido from "./ComnHokkaido";

const ComnMgnt = (props) => {
  const { school, schoolList, setSchool } = useContext(SchoolContext);
  const authToken = localStorage.getItem("accessToken");
  const [deviceId, setDeviceId] = useState(null);
  const history = useHistory();
  const pathname = history["location"].pathname;
  const school_id = Number(pathname.split("/").pop());

  useEffect(() => {
    if (deviceId === null) {
      const Value = JSON.parse(localStorage.getItem("schools"));
      const schoolObj = { id: school_id };
      const controller = new AbortController();
      const signal = controller.signal;
      if (
        Value &&
        Value !== null &&
        Value.some((obj) => obj.id === schoolObj.id)
      ) {
        setDeviceId(Value.find((obj) => obj.id === schoolObj.id).device_id);
        setSchool(Value.find((obj) => obj.id === schoolObj.id).id);
      } else {
        if (schoolList.length > 0) {
          if (idExists(schoolList, school_id)) {
            setSchool(school_id);
            const Id = async (signal) => {
              const res = await getDeviceId(
                schoolList[school_id - 1].place_id,
                authToken,
                signal
              );
              if (res && res.sems_device_id) {
                const value = localStorage.getItem("schools");
                const schools = value ? JSON.parse(value) : [];
                const schoolObj = {
                  id: school_id,
                  device_id: res.sems_device_id,
                };
                schools.push(schoolObj);
                localStorage.setItem("schools", JSON.stringify(schools));
                setDeviceId(res.sems_device_id);
              }
            };
            Id(signal);
            return () => {
              controller.abort();
            };
          } else {
            history.push("/home");
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, schoolList, school_id, deviceId]);

  const getSchoolComponent = () => {
    if (school !== null) {
      const currentSchool = school.user_name;
      switch (true) {
        case currentSchool.includes("岩根"):
          return <ComnIwane deviceId={deviceId} />;
        case currentSchool.includes("太田"):
          return <ComnOta deviceId={deviceId} />;
        case currentSchool.includes("富来田"):
          return <ComnFukida deviceId={deviceId} />;
        case currentSchool.includes("畑沢"):
          return <ComnHatazawa deviceId={deviceId} />;
        case currentSchool.includes("木更津第二"):
          return <ComnSecondJunior deviceId={deviceId} />;
        case currentSchool.includes("請西"):
          return <ComnJozai deviceId={deviceId} />;
        case currentSchool.includes("清見台"):
          return <ComnKiyomidai deviceId={deviceId} />;
        case currentSchool.includes("北海道銀行"):
          return <ComnHokkaido deviceId={deviceId} />;
        case currentSchool.includes("株式会社(ZEH)"):
          return <ComnTest deviceId={deviceId} />;
        case currentSchool.includes("KIC越谷"):
          return <ComnKoshigaya deviceId={deviceId} />;
        case currentSchool.includes("KIC狭山"):
          return <ComnKicSayama deviceId={deviceId} />;
        case currentSchool.includes("KIC厚木"):
          return <ComnAtsugi deviceId={deviceId} />;
        case currentSchool.includes("KICあきる野"):
          return <ComnKicAkiruno deviceId={deviceId} />;
        default:
          return null;
      }
    }
  };
  return (
    <>
      <Container fluid className="p-0 ">
        <Row noGutters>
          <Col>
            <Navbar className="justify-content-center">
              <Nav>
                <NavItem className="text-center text_graph mb-2">
                  通信管理
                </NavItem>
              </Nav>
            </Navbar>
            {getSchoolComponent()}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ComnMgnt;
